module.exports = new __parcel__URL__("facebook.d40a0fe6.svg").toString();